export default __webpack_public_path__ + "images/5bce587f8bd00830559a0325f5ac7243-brain-boosters.svg";